import { get, post } from '@web3/base-utils';
import {
  PostSyncOrderStatusParams,
  PostBindOrderTxParam,
  GetOrderStatusRes,
  GetOrderPageParam,
  GetOrderPageRes,
} from '@/types/order';
import { baseApiUrl } from '@/config/api';

export const postSyncOrderStatus = (params: PostSyncOrderStatusParams) => {
  return post(`${baseApiUrl}/v3/order/syncOrderStatus`, params, {
    useThirdConfig: true,
  });
};

export const postBindOrderTx = (params: PostBindOrderTxParam) => {
  return post(`${baseApiUrl}/v3/order/bindOrderTx`, params, {
    useThirdConfig: true,
  });
};

export const getOrderStatus = (orderCode: string) => {
  return get<GetOrderStatusRes>(`${baseApiUrl}/v3/order/get-order`, {
    orderCode,
  });
};

export const getOrderPage = (params: GetOrderPageParam) => {
  return post<GetOrderPageRes>(`${baseApiUrl}/v3/order/page`, params);
};
